import axios from '../../utils/axios'

import { setAlert } from '../alert/actions'
import { Dispatch } from 'redux'
import {
  GET_BP_USER_HOME_DATA,
  GetBPUserHomeData,
  GET_BP_USER_HOME_DATA_SUCCESS,
  GetBPUserHomeDataSuccess,
  GET_BP_USER_HOME_DATA_FAILED,
  GetBPUserHomeDataFailed,
  GET_BP_USER_SETTINGS,
  GetBPUserSettings,
  GET_BP_USER_SETTINGS_SUCCESS,
  GetBPUserSettingsSuccess,
  GET_BP_USER_SETTINGS_FAILED,
  GetBPUserSettingsFailed,
  BUY_LAND_ASSET,
  BuyUserLandAsset,
  BUY_LAND_ASSET_SUCCESS,
  BuyUserLandAssetSuccess,
  BUY_LAND_ASSET_FAILED,
  BuyUserLandAssetFailed,
  GET_USER_LAND_ASSETS,
  GetUserLandAssets,
  GET_USER_LAND_ASSETS_SUCCESS,
  GetUserLandAssetsSuccess,
  GET_USER_LAND_ASSETS_FAILED,
  GetUserLandAssetsFailed,
  GET_INDIVIDUAL_USER_LAND_ASSETS,
  GetIndividualUserLandAssets,
  GET_INDIVIDUAL_USER_LAND_ASSETS_SUCCESS,
  GetIndividualUserLandAssetsSuccess,
  GET_INDIVIDUAL_USER_LAND_ASSETS_FAILED,
  GetIndividualUserLandAssetsFailed,
  GET_USER_LAND_ASSET_TRANSACTION,
  GetUserLandAssetTransaction,
  GET_USER_LAND_ASSET_TRANSACTION_SUCCESS,
  GetUserLandAssetTransactionSuccess,
  GET_USER_LAND_ASSET_TRANSACTION_FAILED,
  GetUserLandAssetTransactionFailed,

  // ======================================================================

  GET_BP_ADMIN_HOME_DATA,
  GetBPAdminHomeData,
  GET_BP_ADMIN_HOME_DATA_SUCCESS,
  GetBPAdminHomeDataSuccess,
  GET_BP_ADMIN_HOME_DATA_FAILED,
  GetBPAdminHomeDataFailed,
  GET_BP_ADMIN_SETTINGS,
  GetBPAdminSettings,
  GET_BP_ADMIN_SETTINGS_SUCCESS,
  GetBPAdminSettingsSuccess,
  GET_BP_ADMIN_SETTINGS_FAILED,
  GetBPAdminSettingsFailed,
  UPDATE_BP_SETTINGS,
  UpdateBPSettings,
  UPDATE_BP_SETTINGS_SUCCESS,
  UpdateBPSettingsSuccess,
  UPDATE_BP_SETTINGS_FAILED,
  UpdateBPSettingsFailed,
  GET_LAND_ASSETS,
  GetLandAssets,
  GET_LAND_ASSETS_SUCCESS,
  GetLandAssetsSuccess,
  GET_LAND_ASSETS_FAILED,
  GetLandAssetsFailed,
  ADD_LAND_ASSETS,
  AddLandAssets,
  ADD_LAND_ASSETS_SUCCESS,
  AddLandAssetsSuccess,
  ADD_LAND_ASSETS_FAILED,
  AddLandAssetsFailed,
  GET_LAND_ASSET_TRANSACTIONS,
  GetLandAssetsTransactions,
  GET_LAND_ASSET_TRANSACTIONS_SUCCESS,
  GetLandAssetsTransactionsSuccess,
  GET_LAND_ASSET_TRANSACTIONS_FAILED,
  GetLandAssetsTransactionsFailed,
} from './constants'

type formDataType = any

export const getBPUserHomeDataRequest = () => async (
    dispatch: Dispatch<
      | GetBPUserHomeData
      | GetBPUserHomeDataSuccess
      | GetBPUserHomeDataFailed
      | any
    >
  ) => {
    try {
      dispatch({ type: GET_BP_USER_HOME_DATA })
      const res = await axios.get(`/bitplot/home`)
      dispatch({
        type: GET_BP_USER_HOME_DATA_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: GET_BP_USER_HOME_DATA_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: GET_BP_USER_HOME_DATA_FAILED,
          payload: err.message
        })
      }
    }
  }


export const getBPUserSettingsRequest = () => async (
    dispatch: Dispatch<
      | GetBPUserSettings
      | GetBPUserSettingsSuccess
      | GetBPUserSettingsFailed
      | any
    >
  ) => {
    try {
      dispatch({ type: GET_BP_USER_SETTINGS })
      const res = await axios.get(`/bitplot/settings`)

      dispatch({
        type: GET_BP_USER_SETTINGS_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: GET_BP_USER_SETTINGS_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: GET_BP_USER_SETTINGS_FAILED,
          payload: err.message
        })
      }
    }
  }


export const buyUserLandAssetRequest = (formData: formDataType) => async (
    dispatch: Dispatch<
      | BuyUserLandAsset
      | BuyUserLandAssetSuccess
      | BuyUserLandAssetFailed
      | any
    >
  ) => {
    try {
      dispatch({ type: BUY_LAND_ASSET })
      const res = await axios.post(`/bitplot/assets/buy`, formData)
      dispatch(setAlert(res.data.message, 'success'))

      dispatch({
        type: BUY_LAND_ASSET_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: BUY_LAND_ASSET_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: BUY_LAND_ASSET_FAILED,
          payload: err.message
        })
      }
    }
  }

export const getUserLandAssetsRequest = (page?: number | undefined, pageSize?: number | undefined, searchValue?: any, query?: any) => async (
    dispatch: Dispatch<
      GetUserLandAssets | GetUserLandAssetsSuccess | GetUserLandAssetsFailed | any
    >
  ) => {
    try {
      dispatch({ type: GET_USER_LAND_ASSETS })
      let res: any;

      if (searchValue && query) {
        res = await axios.get(`/bitplot/assets?page=${1}&pageSize=${20}&${query}=${searchValue}`)
      } else {
        res = await axios.get(`/bitplot/assets?page=${page ?? 1}&pageSize=${pageSize ?? 20}`)
      }

      dispatch({
        type: GET_USER_LAND_ASSETS_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: GET_USER_LAND_ASSETS_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: GET_USER_LAND_ASSETS_FAILED,
          payload: err.message
        })
      }
    }
  }

export const getIndividualUserLandAssetsRequest = (id) => async (
  dispatch: Dispatch<
    GetIndividualUserLandAssets | GetIndividualUserLandAssetsSuccess | GetIndividualUserLandAssetsFailed | any
  >
) => {
  try {
    dispatch({ type: GET_INDIVIDUAL_USER_LAND_ASSETS })
    let res: any;
    res = await axios.get(`/bitplot/assets/${id}`)

    dispatch({
      type: GET_INDIVIDUAL_USER_LAND_ASSETS_SUCCESS,
      payload: res
    })
  } catch (err: any) {
    if (err.response) {
      dispatch(setAlert(err.response.data.message, 'warning'))
      dispatch({
        type: GET_INDIVIDUAL_USER_LAND_ASSETS_FAILED,
        payload: err.response.data.message
      })
    } else {
      dispatch(setAlert(err.message, 'error'))
      dispatch({
        type: GET_INDIVIDUAL_USER_LAND_ASSETS_FAILED,
        payload: err.message
      })
    }
  }
}

export const getUserLandAssetTransactionRequest = (page?: number | undefined, pageSize?: number | undefined, searchValue?: any, query?: any) => async (
    dispatch: Dispatch<
      | GetUserLandAssetTransaction
      | GetUserLandAssetTransactionSuccess
      | GetUserLandAssetTransactionFailed
      | any
    >
  ) => {
  try {
    dispatch({ type: GET_USER_LAND_ASSET_TRANSACTION })
    let res: any;

    if (searchValue && query) {
      res = await axios.get(`/bitplot/assets/transactions?page=${1}&pageSize=${20}&${query}=${searchValue}`)
    } else {
      res = await axios.get(`/bitplot/assets/transactions?page=${page ?? 1}&pageSize=${pageSize ?? 20}`)
    }

    dispatch(setAlert(res.data.message, 'success'))
    dispatch({
      type: GET_USER_LAND_ASSET_TRANSACTION_SUCCESS,
      payload: res
    })
  } catch (err: any) {
    if (err.response) {
      dispatch(setAlert(err.response.data.message, 'warning'))
      dispatch({
        type: GET_USER_LAND_ASSET_TRANSACTION_FAILED,
        payload: err.response.data.message
      })
    } else {
      dispatch(setAlert(err.message, 'error'))
      dispatch({
        type: GET_USER_LAND_ASSET_TRANSACTION_FAILED,
        payload: err.message
      })
    }
  }
}

  // ========================================================================

export const getBPAdminHomeDataRequest = () => async (
  dispatch: Dispatch<
    | GetBPAdminHomeData
    | GetBPAdminHomeDataSuccess
    | GetBPAdminHomeDataFailed
    | any
  >
) => {
  try {
    dispatch({ type: GET_BP_ADMIN_HOME_DATA })
    const res = await axios.get(`/bitplot/home/admin`)

    dispatch(setAlert(res.data.message, 'success'))
    dispatch({
      type: GET_BP_ADMIN_HOME_DATA_SUCCESS,
      payload: res
    })
  } catch (err: any) {
    if (err.response) {
      dispatch(setAlert(err.response.data.message, 'warning'))
      dispatch({
        type: GET_BP_ADMIN_HOME_DATA_FAILED,
        payload: err.response.data.message
      })
    } else {
      dispatch(setAlert(err.message, 'error'))
      dispatch({
        type: GET_BP_ADMIN_HOME_DATA_FAILED,
        payload: err.message
      })
    }
  }
}

export const getBPAdminHomeSettingsRequest = () => async (
  dispatch: Dispatch<
    | GetBPAdminSettings
    | GetBPAdminSettingsSuccess
    | GetBPAdminSettingsFailed
    | any
  >
) => {
  try {
    dispatch({ type: GET_BP_ADMIN_SETTINGS })
    const res = await axios.get(`/bitplot/settings`)

    dispatch(setAlert(res.data.message, 'success'))
    dispatch({
      type: GET_BP_ADMIN_SETTINGS_SUCCESS,
      payload: res
    })
  } catch (err: any) {
    if (err.response) {
      dispatch(setAlert(err.response.data.message, 'warning'))
      dispatch({
        type: GET_BP_ADMIN_SETTINGS_FAILED,
        payload: err.response.data.message
      })
    } else {
      dispatch(setAlert(err.message, 'error'))
      dispatch({
        type: GET_BP_ADMIN_SETTINGS_FAILED,
        payload: err.message
      })
    }
  }
}

export const updateBPSettingsRequest = (formData: formDataType) => async (
  dispatch: Dispatch<
    | UpdateBPSettings
    | UpdateBPSettingsSuccess
    | UpdateBPSettingsFailed
    | any
  >
) => {
  try {
    dispatch({ type: UPDATE_BP_SETTINGS })
    const res = await axios.put(`/bitplot/settings`, formData)

    dispatch(setAlert(res.data.message, 'success'))
    dispatch({
      type: UPDATE_BP_SETTINGS_SUCCESS,
      payload: res
    })
  } catch (err: any) {
    if (err.response) {
      dispatch(setAlert(err.response.data.message, 'warning'))
      dispatch({
        type: UPDATE_BP_SETTINGS_FAILED,
        payload: err.response.data.message
      })
    } else {
      dispatch(setAlert(err.message, 'error'))
      dispatch({
        type: UPDATE_BP_SETTINGS_FAILED,
        payload: err.message
      })
    }
  }
}

export const addLandAssetsRequest = (formData: formDataType) => async (
  dispatch: Dispatch<
    | AddLandAssets
    | AddLandAssetsSuccess
    | AddLandAssetsFailed
    | any
  >
) => {
  try {
    dispatch({ type: ADD_LAND_ASSETS })
    const res = await axios.post(`/bitplot/assets/add`, formData)

    dispatch(setAlert(res.data.message, 'success'))
    dispatch({
      type: ADD_LAND_ASSETS_SUCCESS,
      payload: res
    })
  } catch (err: any) {
    if (err.response) {
      dispatch(setAlert(err.response.data.message, 'warning'))
      dispatch({
        type: ADD_LAND_ASSETS_FAILED,
        payload: err.response.data.message
      })
    } else {
      dispatch(setAlert(err.message, 'error'))
      dispatch({
        type: ADD_LAND_ASSETS_FAILED,
        payload: err.message
      })
    }
  }
}

export const getLandAssetsRequest = (page?: number | undefined, pageSize?: number | undefined, searchValue?: any, query?: any) => async (
  dispatch: Dispatch<
    | GetLandAssets
    | GetLandAssetsSuccess
    | GetLandAssetsFailed
    | any
  >
) => {
  try {
    dispatch({ type: GET_LAND_ASSETS })
    let res: any;

    if (searchValue && query) {
      res = await axios.get(`/bitplot/assets/?page=${1}&pageSize=${20}&${query}=${searchValue}`)
    } else {
      res = await axios.get(`/bitplot/assets/?page=${page ?? 1}&pageSize=${pageSize ?? 20}`)
    }

    dispatch(setAlert(res.data.message, 'success'))
    dispatch({
      type: GET_LAND_ASSETS_SUCCESS,
      payload: res
    })
  } catch (err: any) {
    if (err.response) {
      dispatch(setAlert(err.response.data.message, 'warning'))
      dispatch({
        type: GET_LAND_ASSETS_FAILED,
        payload: err.response.data.message
      })
    } else {
      dispatch(setAlert(err.message, 'error'))
      dispatch({
        type: GET_LAND_ASSETS_FAILED,
        payload: err.message
      })
    }
  }
}

export const getLandAssetsTransactionsRequest = (page?: number | undefined, pageSize?: number | undefined, searchValue?: any, query?: any) => async (
  dispatch: Dispatch<
    | GetLandAssetsTransactions
    | GetLandAssetsTransactionsSuccess
    | GetLandAssetsTransactionsFailed
    | any
  >
) => {
  try {
    dispatch({ type: GET_LAND_ASSET_TRANSACTIONS })

    let res: any;

    if (searchValue && query) {
      res = await axios.get(`/bitplot/assets/transactions?page=${1}&pageSize=${20}&${query}=${searchValue}`)
    } else {
      res = await axios.get(`/bitplot/assets/transactions?page=${page ?? 1}&pageSize=${pageSize ?? 20}`)
    }

    dispatch(setAlert(res.data.message, 'success'))
    dispatch({
      type: GET_LAND_ASSET_TRANSACTIONS_SUCCESS,
      payload: res
    })
  } catch (err: any) {
    if (err.response) {
      dispatch(setAlert(err.response.data.message, 'warning'))
      dispatch({
        type: GET_LAND_ASSET_TRANSACTIONS_FAILED,
        payload: err.response.data.message
      })
    } else {
      dispatch(setAlert(err.message, 'error'))
      dispatch({
        type: GET_LAND_ASSET_TRANSACTIONS_FAILED,
        payload: err.message
      })
    }
  }
}
